import React, { useState } from "react";
import {
  FaAndroid,
  FaGlobe,
  FaMobileAlt,
  FaShoppingCart,
  FaUserTie,
} from "react-icons/fa";
import { FaAngleUp, FaDesktop } from "react-icons/fa6";
import selectType from "../../../assets/Docs/selectType.png";
import Buyer_details from "../../../assets/Docs/buyerbussinesdetails.png";
import Buyer_Dashboard from "../../../assets/Docs/buyerDashboard.png";
import { TagComponent } from "../Tabs";

const BuyerSetup = () => {
  const [activeTab, setActiveTab] = useState("web");
  const [activeTab1, setActiveTab1] = useState("web");
  const [activeTab2, setActiveTab2] = useState("web");

  const handleTabClick = (tabId, setActive) => {
    setActive(tabId);
  };

  const tabs = [
    { id: "web", label: "Web App", icon: <FaDesktop /> },
    {
      id: "mobile",
      label: "Mobile App",
      icon: <FaMobileAlt />,
      disabled: true,
    },
  ];


  const renderTabs = (activeState, setActiveState) => (
    <div className="flex flex-col sm:flex-row gap-2 border-b border-[#b9ece6] sm:gap-4 mb-6">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => !tab.disabled && setActiveState(tab.id)}
          className={`flex items-center justify-center sm:justify-start gap-2 px-4 py-2 rounded-t-md transition-all text-sm w-full sm:w-auto ${activeState === tab.id
              ? "bg-[#1a9588] text-white shadow"
              : "bg-[#dbf4f1] text-gray-700 hover:bg-[#b9ece6]"
            } ${tab.disabled ? "opacity-50 cursor-not-allowed hover:bg-[#dbf4f1]" : ""}`}
          disabled={tab.disabled}
        >
          {tab.icon}
          {tab.label}
        </button>
      ))}
    </div>
  );

  return (
    <div className="bg-white shadow-lg rounded-xl p-6 sm:p-8  mx-auto border border-gray-200" id="top">

      <div className="flex items-center mb-6 border-b pb-4 border-gray-200">
        <FaShoppingCart className="text-4xl text-theme-logo-color mr-3" />
        <h1 className="text-2xl sm:text-3xl font-bold text-theme-logo-color">Buyer Setup (For Placing Orders)</h1>
      </div>


      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4">
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaUserTie />} label="Seller" color="pink" />
          <TagComponent icon={<FaShoppingCart />} label="Buyer" color="green" />
        </div>
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaGlobe />} label="Web" color="green" />
          <TagComponent icon={<FaAndroid />} label="Android" color="green" />
        </div>
      </div>

      <hr className="my-6" />

      <div className="flex flex-col md:flex-row gap-8 scroll-smooth">
        <div className="md:w-1/4 lg:w-1/4 w-full p-4 sticky top-4 self-start">
          <div className="bg-[#dbf4f1] text-start p-4 rounded-lg">
            <ul className="space-y-2">
              <li className="font-semibold text-lg text-gray-700">
                Select a Section
              </li>
              <li className="border-t border-[#abe7e0] my-2"></li>
              <li>
                <a
                  href="#start-setup"
                  className="text-gray-600 hover:underline"
                >
                  Start Setup
                </a>
              </li>
              <li className="border-t border-[#abe7e0] my-2"></li>
              <li>
                <a
                  href="#create-your-buyer-profile"
                  className="text-gray-600 hover:underline"
                >
                  Create Your Buyer Profile
                </a>
              </li>
              <li className="border-t border-[#abe7e0] my-2"></li>
              <li>
                <a
                  href="#setup-complete"
                  className="text-gray-600 hover:underline"
                >
                  Setup Complete
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="md:w-3/4 lg:w-3/4 w-full p-4 text-start">
          <div id="start-setup" className="scroll-mt-20">
            <h3 className="text-2xl text-gray-500 mb-2 font-semibold">
              Select Option 2 - I'm a Buyer
            </h3>
            <p className="text-gray-400 mb-6">
              After signing up, the first screen you see is the "Let's Get
              Started" screen. To start placing orders, you need to become a
              'Buyer' on the Selzor platform. Click 'Start Buyer Setup' to
              continue.
            </p>
            {renderTabs(activeTab, setActiveTab)}
            <div className="mt-4 p-4 border border-gray-200 rounded-lg">
              {activeTab === "web" && (
                <img
                  src={selectType}
                  alt="Web App View of Seller Setup"
                  className="w-full h-auto"
                />
              )}
              {activeTab === "mobile" && (
                <img
                  src=""
                  alt="Mobile App View of Seller Setup"
                  className="w-full h-auto"
                />
              )}
            </div>
          </div>
          <div className="flex justify-end my-4">
            <a href="#top" className="text-blue-600 hover:underline">
              <FaAngleUp />
            </a>
          </div>
          <hr className="my-6" />

          <div id="create-your-buyer-profile" className="scroll-mt-20">
            <div className="flex justify-between items-center mb-2">
              <h3 className="text-2xl text-gray-500 font-semibold">
                Create Your Buyer Profile
              </h3>
              <span className="bg-gray-400 text-white text-xs font-semibold px-2 py-1 rounded-lg">
                Step 1 of 3
              </span>
            </div>
            <p className="text-gray-400 mb-6 ">
              Create your buyer profile by entering in some basic information -
              Primary Contact, Company Name, Company Initials & Postal Address
              Details.
            </p>
            {renderTabs(activeTab1, setActiveTab1)}
            <div className="mt-4 p-4 border border-gray-200 rounded-lg">
              {activeTab1 === "web" && (
                <img
                  src={Buyer_details}
                  alt="Web App View of Seller Profile"
                  className="w-full h-auto"
                />
              )}
              {activeTab1 === "mobile" && (
                <img
                  src=""
                  alt="Mobile App View of Seller Profile"
                  className="w-full h-auto"
                />
              )}
            </div>
          </div>
          <div className="flex justify-end my-4">
            <a href="#top" className="text-blue-600 hover:underline">
              <FaAngleUp />
            </a>
          </div>
          <hr className="my-6" />

          <div id="setup-complete" className="scroll-mt-20">
            <div className="flex justify-between items-center mb-2">
              <h3 className="text-2xl text-gray-500 font-semibold">Setup Complete</h3>
              <span className="bg-gray-400 text-white text-xs font-semibold px-2 py-1 rounded-lg">
                Step 2 of 3
              </span>
            </div>
            
            <p className="text-gray-400 mb-6">
              That's it, your Buyer Setup is now complete. You can now place
              orders to your suppliers.
            </p>
            {renderTabs(activeTab2, setActiveTab2)}
            <div className="mt-4 p-4 border border-gray-200 rounded-lg">
              {activeTab2 === "web" && (
                <img
                  src={Buyer_Dashboard}
                  alt="Web App View of Product Attributes"
                  className="w-full h-auto"
                />
              )}
              {activeTab2 === "mobile" && (
                <img
                  src=""
                  alt="Mobile App View of Product Attributes"
                  className="w-full h-auto"
                />
              )}
            </div>
            <div className="text-start py-5 mt-3">
              <div>
                <h3 className="text-gray-600 font-semibold text-lg pb-3">
                  Related Topics
                </h3>
                <div className="text-sm text-gray-500">
                  <div>
                    <a
                      href="Suppliers"
                      className=" hover:underline hover:text-[#1a9588]"
                    >
                      Adding Suppliers
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex justify-end my-4">
            <a href="#top" className="text-blue-600 hover:underline">
              <FaAngleUp />
            </a>
          </div>
          <hr className="my-6" />
        </div>
      </div>
    </div>
  );
};

export default BuyerSetup;
